import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import TextfieldInput from "../../Shared/TextField";
import { TextField, MenuItem, Select, Grid2, Snackbar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box } from "@mui/material";
import Chip from "../../Shared/ui/Chip";
import Tooltip from "../../Shared/Tooltip";
import QRCode from "qrcode.react";
import ApiMeasurementQrButton from "./Components/ApiMeasurementQrButton";
import ApiHelper from "../../../Utils/API/apiHelper";

import ButtonNormalText from "../../Shared/Buttons/ButtonNormalText";
import ButtonNormalDelete from "../../Shared/Buttons/ButtonNormalDelete";
import { dataService } from "../../../Services/data/data.service";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { externalApiTypes, externalApiEnumBehaviorTypes } from "../../../Config/constants";
import BoolToggle from "../../Shared/Buttons/BoolToggle";
import TableList from "./Components/ModifyExternalApiList";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import * as apiHelper from "../../../Utils/API/apiHelper";

import HowToUseAPIDialog from "./Components/HowToUseAPIDialog";

import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Save, ClipboardCopy, Trash2, Plus, Pencil } from "lucide-react";
import BackButton from "../../Shared/Buttons/BackButton";
import Button from "../../Shared/Buttons/Button";

function ModifyExternalApiPage(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const appSettings = ApiHelper.appSettings;
  const navigate = useNavigate();
  const apiUniqueId = useParams().apiUniqueId;
  var today = new Date();

  const [allExternalApiTypes, setAllExternalApiTypes] = useState([]);
  const [allUserCompanies, setAllUserCompanies] = useState([]);

  const [connectionName, setConnectionName] = useState("");
  const [connectionDesc, setConnectionDesc] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const [company, setCompany] = useState(null);
  const [apiKey, setApiKey] = useState("");
  const [errorConnectionName, setErrorConnectionName] = useState(false);
  const [errorApiKey, setErrorApiKey] = useState(false);
  const [errorCompany, setErrorCompany] = useState("");
  const [helperTextCompany, setHelperTextCompany] = useState("");

  // Example body JSON
  const [exampleBody, setExampleBody] = useState({
    keyValue: "Your data here",
  });
  const [usingCustomReference, setUsingCustomReference] = useState(false); // Determines which stopwatch rows to show

  const [htConnectionName, setHtConnectionName] = useState("");
  const [htApiKey, setHtApiKey] = useState("");
  const [emptyDetails, setEmptyDetails] = useState(false);
  const [apiBodyItems, setApiBodyItems] = useState([]);
  const [apiExampleLink, setApiExampleLink] = useState("");
  const [apiExamplePoints, setApiExamplePoints] = useState("");
  const [ApiId, setApiId] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const [delopen, setDelOpen] = useState(false);

  const [apiTypeId, setApiTypeId] = useState(null);
  const [externalApiType, setExternalApiType] = useState(null);
  const [helperTextExternalApiType, setHelperTextExternalApiType] = useState("");
  const [errorExternalApiType, setErrorExternalApiType] = useState("");
  const [registrationPoints, setRegistrationPoints] = useState([]); // Points for registration API

  const [howToOpen, setHowToOpen] = useState(false); // Open How to use API dialog

  // Enum options state
  const [enumOptions, setEnumOptions] = useState([]);
  const [newEnumValue, setNewEnumValue] = useState("");
  const [newEnumDescription, setNewEnumDescription] = useState("");
  const [editingEnumId, setEditingEnumId] = useState(null);
  const [editEnumValue, setEditEnumValue] = useState("");
  const [editEnumDescription, setEditEnumDescription] = useState("");
  const [enumError, setEnumError] = useState(false);

  // Enum behavior type (read-only, set at creation)
  const [enumBehaviorTypeId, setEnumBehaviorTypeId] = useState(null);
  const [sessionDurationMinutes, setSessionDurationMinutes] = useState(null);

  useEffect(() => {
    dataService.getExternalApiByUniqueId(apiUniqueId).then((results) => {
      setConnectionName(results.name);
      setConnectionDesc(results.description);
      setApiKey(results.apiKey);
      setApiId(results.id);
      setApiTypeId(results.externalApiTypeId);
      setEnumBehaviorTypeId(results.externalApiEnumBehaviorTypeId);
      setSessionDurationMinutes(results.sessionDurationMinutes);
      setApiExampleLink(apiHelper.ComposeUri(apiHelper.EXTERNALAPI) + results.apiKey);
      setRegistrationPoints(results.registrationPoints);

      var apiFormatParsed = JSON.parse(results.apiFormat);
      var apiFormat = apiFormatParsed.map((item, index) => ({ Id: index + 1, itemDescription: item.Description, edit: false, itemName: item.Name, UserId: props.Login.userid, InsertedOn: today }));
      setApiBodyItems(apiFormat);

      var ExampleApiValuesMapped = apiFormat.map((item) => ({ [item.itemName]: "Your data here" }));
      var NewExampleApiValues = JSON.stringify(Object.assign({}, ...ExampleApiValuesMapped), null, 2);
      setApiExamplePoints(NewExampleApiValues);
      setExampleBody(NewExampleApiValues);

      setCompanyId(results.companyId);
    });
  }, [props.Login.userid]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (companyId) {
      dataService.getAllCompaniesByUserId(props.Login.userid).then((results) => {
        setCompany(results.find((x) => x.id === companyId));
        setAllUserCompanies(results);
      });
    }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (apiTypeId) {
      dataService.getAllExternalApiTypes().then((results) => {
        setAllExternalApiTypes(results);
        setExternalApiType(results.find((x) => x.id === apiTypeId));
      });
    }
  }, [apiTypeId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (ApiId && apiTypeId === externalApiTypes.ENUM) {
      dataService.getEnumOptionsByExternalApiId(ApiId).then((results) => {
        setEnumOptions(results || []);
      });
    }
  }, [ApiId, apiTypeId]);

  const handleDialogOpenDel = () => {
    setDelOpen(true);
  };
  const handleDialogCloseDel = () => {
    setDelOpen(false);
  };

  const setConnectionNameState = (event) => {
    setConnectionName(event.target.value);
  };

  const setConnectionDescState = (event) => {
    setConnectionDesc(event.target.value);
  };

  const setApiKeyState = (event) => {
    setApiKey(event.target.value);
  };

  // switch between stopwatch with customReference and stopwatch with provided reference
  const handleStopwatchExampleBody = (usingCustomReference) => {
    setUsingCustomReference(usingCustomReference);
    let tempStopwatchItems = [];
    if (!usingCustomReference) {
      tempStopwatchItems = [
        {
          Id: 1,
          itemName: "stopwatchReference",
          itemDescription: "Reference to stop a earlier started stopwatch",
        },
        {
          Id: 2,
          itemName: "startTime",
          itemDescription: "The time the stopwatch starts",
        },
        {
          Id: 3,
          itemName: "stopTime",
          itemDescription: "The time the stopwatch stops",
        },
        {
          Id: 4,
          itemName: "keyValue",
          itemDescription: "Optional key value (can be used to link an api measurement to an order)",
        },
        {
          Id: 5,
          itemName: "singleTimer",
          itemDescription: "When true, starting a new timer will stop other running timers on this API",
        },
      ];
    } else {
      tempStopwatchItems = [
        {
          Id: 1,
          itemName: "customReference",
          itemDescription: "Reference to stop a earlier started stopwatch",
        },
        {
          Id: 2,
          itemName: "startTime",
          itemDescription: "The time the stopwatch starts",
        },
        {
          Id: 3,
          itemName: "stopTime",
          itemDescription: "The time the stopwatch stops",
        },
        {
          Id: 4,
          itemName: "keyValue",
          itemDescription: "Optional key value (can be used to link an api measurement to an order)",
        },
        {
          Id: 5,
          itemName: "useRefAsKey",
          itemDescription: "Optional, if true the customReference will be used as keyValue",
        },
        {
          Id: 6,
          itemName: "singleTimer",
          itemDescription: "When true, starting a new timer will stop other running timers on this API",
        },
      ];
    }

    var ExampleApiValuesMapped = tempStopwatchItems.map((item) => ({ [item.itemName]: "Your data here" }));
    var NewExampleApiValues = JSON.stringify(Object.assign({}, ...ExampleApiValuesMapped), null, 2);
    setExampleBody(NewExampleApiValues);
  };

  const setRows = (event) => {
    setApiBodyItems(event);
    var ExampleApiValuesMapped = event.map((item) => ({ [item.itemName]: "Your data here" }));
    var NewExampleApiValues = JSON.stringify(Object.assign({}, ...ExampleApiValuesMapped), null, 2);
    setApiExamplePoints(NewExampleApiValues);
    setExampleBody(NewExampleApiValues);
  };

  const validate = () => {
    var validationOK = true;
    if (connectionName === "") {
      validationOK = false;
      setHtConnectionName(t('modifyExternalApi.enterConnectionName'));
      setErrorConnectionName(true);
    } else {
      setHtConnectionName("");
      setErrorConnectionName(false);
    }

    if (!company) {
      validationOK = false;
      setHelperTextCompany(t('modifyExternalApi.selectCompanyError'));
      setErrorCompany(true);
    } else {
      setHelperTextCompany("");
      setErrorCompany(false);
    }

    if (apiKey === "") {
      validationOK = false;
      setHtApiKey(t('modifyExternalApi.generateApiKey'));
      setErrorApiKey(true);
    } else {
      setErrorApiKey(false);
      setHtApiKey("");
    }

    if (apiBodyItems.length === 0 || apiBodyItems[0].itemName === "") {
      validationOK = false;
      setEmptyDetails(true);
    } else {
      setEmptyDetails(false);
    }

    if (apiTypeId === externalApiTypes.ENUM && enumOptions.length === 0) {
      validationOK = false;
      setEnumError(true);
    } else {
      setEnumError(false);
    }

    return validationOK;
  };

  const sendToApi = () => {
    setApiBodyItems(
      apiBodyItems.map((x) => ({
        ...x,
        edit: false,
      }))
    );
    setApiExampleLink(apiHelper.ComposeUri(apiHelper.EXTERNALAPI) + apiKey);
    var ExampleApiValuesMapped = apiBodyItems.map((item) => ({ [item.itemName]: "Your data here" }));
    var NewExampleApiValues = JSON.stringify(Object.assign({}, ...ExampleApiValuesMapped), null, 2);
    let userid = props.Login.userid;
    setApiExamplePoints(NewExampleApiValues);
    if (validate()) {
      var items = JSON.stringify(apiBodyItems.map((item) => ({ Name: item.itemName, Description: item.itemDescription })));
      dataService.modifyApi(ApiId, connectionName, connectionDesc, company.id, apiKey, items, userid, sessionDurationMinutes).then((response) => {
        if (response.success === true) {
          toast.success(t('modifyExternalApi.savedSuccessfully'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        } else {
          toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        }
      });
    }
  };

  const handleOpenToast = () => {
    setOpenToast(true);
  };

  const handleCloseToast = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };

  const handleCopyLink = () => {
    handleOpenToast();
    navigator.clipboard.writeText(apiExampleLink);
  };

  const handleCopyFormat = () => {
    handleOpenToast();
    navigator.clipboard.writeText(apiExamplePoints);
  };

  const handleDeleteExternalApi = () => {
    let userid = props.Login.userid;
    var items = JSON.stringify(apiBodyItems.map((item) => ({ Name: item.itemName, Description: item.itemDescription })));
    dataService.deleteApi(ApiId, connectionName, connectionDesc, apiKey, items, userid).then((response) => {
      if (response.success === true) {
        toast.success(t('modifyExternalApi.deletedSuccessfully'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      } else {
        toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
      navigate("/externalapioverview");
    });
  };

  const handleTutorialDialog = () => {
    setHowToOpen(true);
  };

  // Enum option handlers - directly interact with API since the API already exists
  const loadEnumOptions = () => {
    dataService.getEnumOptionsByExternalApiId(ApiId).then((results) => {
      setEnumOptions(results || []);
    });
  };

  const addEnumOption = () => {
    if (newEnumValue.trim() === "") return;
    dataService.createEnumOption(ApiId, newEnumValue.trim(), newEnumDescription.trim(), props.Login.userid).then(() => {
      loadEnumOptions();
      setNewEnumValue("");
      setNewEnumDescription("");
      setEnumError(false);
      toast.success(t('modifyExternalApi.enumOptionAdded'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
    });
  };

  const removeEnumOption = (id) => {
    dataService.deleteEnumOption(id, props.Login.userid).then(() => {
      loadEnumOptions();
      toast.success(t('modifyExternalApi.enumOptionRemoved'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
    });
  };

  const startEditEnumOption = (option) => {
    setEditingEnumId(option.id);
    setEditEnumValue(option.value);
    setEditEnumDescription(option.description || "");
  };

  const saveEditEnumOption = () => {
    if (editEnumValue.trim() === "") return;
    dataService.modifyEnumOption(editingEnumId, editEnumValue.trim(), editEnumDescription.trim(), props.Login.userid).then(() => {
      loadEnumOptions();
      setEditingEnumId(null);
      setEditEnumValue("");
      setEditEnumDescription("");
      toast.success(t('modifyExternalApi.enumOptionUpdated'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
    });
  };

  const isDefaultStopwatchKey = (itemName) => {
    return itemName === "stopwatchReference" || itemName === "startTime" || itemName === "stopTime" || itemName === "keyValue" || itemName === "singleTimer";
  };

  const isDefaultDataKey = (itemName) => {
    return itemName === "keyValue";
  };

  // Function to generate QR code URLs with non-default API body items
  const generateQRCodeUrl = (baseUrl, action) => {
    let endpoint = "";
    switch (action) {
      case "Start":
        endpoint = "NewExternalApiMeasurementStart";
        break;
      case "Stop":
        endpoint = "NewExternalApiMeasurementStop";
        break;
      case "LinearStopwatch":
        endpoint = "NewExternalApiMeasurementLinearStopwatch";
        break;
      case "Count":
        endpoint = "NewExternalApiMeasurementQuery";
        break;
      default:
        break;
    }

    let url = `${appSettings.TAPLR_API_BASE_URL}/ExternalApiMeasurementLogic/${endpoint}?apiKey=${apiKey}`;

    // Add default parameters
    if (apiTypeId === externalApiTypes.NUMERIC) {
      url += `&value=1`;
    } else if (apiTypeId === externalApiTypes.STOPWATCH) {
      url += "&customReference=taplrqrmeasurement";
    }

    // Add non-default API body items as query parameters
    if (apiBodyItems && apiBodyItems.length > 0) {
      const nonDefaultItems = apiBodyItems.filter((item) => {
        if (apiTypeId === externalApiTypes.STOPWATCH) {
          return !isDefaultStopwatchKey(item.itemName) && item.itemName !== "customReference" && item.itemName !== "useRefAsKey" && item.itemName !== "singleTimer";
        } else if (apiTypeId === externalApiTypes.DATA) {
          return !isDefaultDataKey(item.itemName);
        } else if (apiTypeId === externalApiTypes.NUMERIC) {
          // exclude optional items
          return item.itemName !== "keyValue" && item.itemName !== "measurementTime" && item.itemName !== "value" && item.itemName !== "customReference";
        }
        return true; // For other API types, include all items
      });

      nonDefaultItems.forEach((item) => {
        if (item.itemName && item.itemName.trim() !== "") {
          url += `&${encodeURIComponent(item.itemName)}=-`;
        }
      });
    }

    return url;
  };

  const getQrButtonTooltipContent = (action) => {
    switch (action) {
      case "Start":
        return t('modifyExternalApi.qrTooltipStart');
      case "Stop":
        return t('modifyExternalApi.qrTooltipStop');
      case "LinearStopwatch":
        return t('modifyExternalApi.qrTooltipLinearStopwatch');
      case "Count":
        return t('modifyExternalApi.qrTooltipCount');
      default:
        return t('modifyExternalApi.qrTooltipDefault');
    }
  };

  return (
    <React.Fragment>
      <Box className="page-container">
        <div className="page-header">
          <BackButton onClick={() => navigate("/externalapioverview")}>{t('modifyExternalApi.backToApiOverview')}</BackButton>
          <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
            <h1>{t('modifyExternalApi.title')}</h1>
            <Tooltip
              content={
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                  {registrationPoints.length > 0 &&
                    registrationPoints.map((point, index) => (
                      <div key={index} style={{ display: "flex", gap: "8px", alignItems: "center", height: "fit-content" }}>
                        <div style={{ width: "2px", borderRadius: "2px", height: "36px", backgroundColor: "var(--color-primary)", display: "inline-block" }} />
                        <div style={{ display: "flex", flexDirection: "column", gap: "0px", alignItems: "flex-start" }}>
                          <p style={{ fontSize: "1rem" }}>{point.name}</p>
                          <p style={{ fontSize: ".875rem", opacity: "0.8" }}>{point.projectName}</p>
                        </div>
                      </div>
                    ))}
                  {registrationPoints.length === 0 && <p style={{ fontSize: "1rem", opacity: "0.8" }}>{t('modifyExternalApi.noImplementations')}</p>}
                </div>
              }
              position="bottom"
            >
              <Chip>{t('modifyExternalApi.registrationPointsCount', { count: registrationPoints.length })}</Chip>
            </Tooltip>
          </div>
        </div>

        <div className={classes.container}>
          <div className={classes.formContainer}>
            <div className={classes.formColumn}>
              <div className={classes.projectOption}>
                {/* <DescriptionItem Text="Name of your connection" /> */}
                <div className={classes.projectOption__labelContainer}>
                  {htConnectionName === "" ? <label className={classes.labelContainer__label}>{t('modifyExternalApi.apiName')}</label> : <label className={classes.labelContainer__helperText}>{htConnectionName}</label>}
                </div>
                <TextfieldInput label={connectionName ? " " : t('modifyExternalApi.connectionPlaceholder')} InputLabelProps={{ shrink: false }} value={connectionName} action={setConnectionNameState} error={errorConnectionName} />
              </div>
              <div className={classes.projectOption}>
                <div className={classes.projectOption__labelContainer}>
                  <p className={classes.labelContainer__label}>{t('modifyExternalApi.selectCompany')}</p>
                  <p className={classes.labelContainer__helperText}>{helperTextCompany}</p>
                </div>
                <Select
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  displayEmpty
                  error={errorCompany}
                  helperText={helperTextCompany}
                  style={{ width: "100%" }}
                  renderValue={company !== "" ? undefined : () => t('modifyExternalApi.companyPlaceholder')}
                >
                  {/* If no company is selected, this is a placeholder */}
                  {allUserCompanies.length < 1 && (
                    <MenuItem value="">
                      <em>{t('modifyExternalApi.notPartOfCompany')}</em>
                    </MenuItem>
                  )}
                  {/* Populate the dropdown with companies from allUserCompanies */}
                  {allUserCompanies.map((company, index) => (
                    <MenuItem key={index} value={company}>
                      {company.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className={classes.projectOption}>
                <div className={classes.projectOption__labelContainer}>
                  {helperTextExternalApiType === "" ? (
                    <label className={classes.labelContainer__label}>{t('modifyExternalApi.selectApiType')}</label>
                  ) : (
                    <label className={classes.labelContainer__helperText}>{helperTextExternalApiType}</label>
                  )}
                </div>
                <Select
                  value={externalApiType}
                  disabled
                  onChange={(e) => setExternalApiType(e.target.value)}
                  displayEmpty
                  error={errorExternalApiType}
                  helperText={helperTextExternalApiType}
                  style={{ width: "100%" }}
                  renderValue={externalApiType !== "" ? undefined : () => t('modifyExternalApi.apiTypePlaceholder')}
                >
                  {/* If no company is selected, this is a placeholder */}
                  {allExternalApiTypes.length < 1 && (
                    <MenuItem value="">
                      <em>{t('modifyExternalApi.noTypesAvailable')}</em>
                    </MenuItem>
                  )}
                  {/* Populate the dropdown with companies from allUserCompanies */}
                  {allExternalApiTypes
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((apiType, index) => (
                      <MenuItem key={index} value={apiType}>
                        {apiType.name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </div>
            <div className={classes.listDescriptionStyle}>
              <div className={classes.projectOption__labelContainer}>
                <p className={classes.labelContainer__label}>{t('modifyExternalApi.apiDescription')}</p>
              </div>
              <textarea className={classes.description__textarea} value={connectionDesc} onChange={(e) => setConnectionDescState(e)}></textarea>
              {/* <TextfieldInput label={connectionDesc ? " " : "Description"} InputLabelProps={{ shrink: false }} rows={3} multiline value={connectionDesc} action={setConnectionDescState} /> */}
            </div>
          </div>
          <div className={classes.listDescriptionStyle}>
            <div className={classes.projectOption__labelContainer}>
              <p className={classes.labelContainer__label}>{t('modifyExternalApi.apiKey')}</p>
            </div>
            <div className={classes.generateApiKeyContainer}>
              <TextField value={apiKey} fullWidth placeholder={t('modifyExternalApi.apiKey')} slotProps={{ readOnly: true }} />
            </div>
          </div>
          {emptyDetails === true ? (
            <div style={{ marginTop: "24px" }}>
              <label className={classes.label}>{t('modifyExternalApi.addDataPoints')}</label>
              <Grid2 item xs={12} sm={12} md={12} style={{ border: "solid 2px", borderColor: "#d32f2f", borderRadius: "17px", marginTop: "4px" }}>
                <TableList {...props} rows={apiBodyItems} setRows={setRows} apiTypeId={externalApiType && externalApiType.id} makeSave={sendToApi} />
              </Grid2>
              <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>{t('modifyExternalApi.atLeastOneDataPoint')}</p>
            </div>
          ) : (
            <div style={{ marginTop: "24px" }}>
              <label className={classes.label}>{t('modifyExternalApi.addDataPoints')}</label>
              <Grid2 item xs={12} sm={12} md={12} style={{ marginTop: "4px" }}>
                <TableList {...props} rows={apiBodyItems} setRows={setRows} apiTypeId={externalApiType && externalApiType.id} />
              </Grid2>
            </div>
          )}
          {apiTypeId === externalApiTypes.ENUM && (
            <div style={{ marginTop: "24px" }}>
              <label className={classes.label}>{t('modifyExternalApi.enumBehaviorType')}</label>
              <div style={{ marginTop: "4px", marginBottom: "1rem" }}>
                <TextField
                  disabled
                  value={enumBehaviorTypeId === externalApiEnumBehaviorTypes.ANCHOR ? t('modifyExternalApi.enumAnchor') : enumBehaviorTypeId === externalApiEnumBehaviorTypes.STICKY ? t('modifyExternalApi.enumSticky') : t('modifyExternalApi.enumStandard')}
                  variant="outlined"
                  style={{ minWidth: "220px" }}
                  helperText={t('modifyExternalApi.behaviorTypeHelperText')}
                />
              </div>
              {enumBehaviorTypeId === externalApiEnumBehaviorTypes.STICKY && (
                <div style={{ marginTop: "4px", marginBottom: "1rem" }}>
                  <label className={classes.label}>{t('modifyExternalApi.activeDuration')}</label>
                  <div style={{ marginTop: "4px" }}>
                    <TextField
                      value={sessionDurationMinutes ?? ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSessionDurationMinutes(val === "" ? null : parseInt(val, 10));
                      }}
                      variant="outlined"
                      type="number"
                      style={{ minWidth: "220px" }}
                      placeholder={t('modifyExternalApi.leaveEmptyIndefinite')}
                      helperText={t('modifyExternalApi.stickyDurationHelperText')}
                    />
                  </div>
                </div>
              )}
              <label className={classes.label}>{t('modifyExternalApi.defineEnumOptions')}</label>
              <div className={classes.enumContainer}>
                <div className={classes.enumInputRow}>
                  <TextField
                    label={t('modifyExternalApi.optionValue')}
                    variant="outlined"
                    value={newEnumValue}
                    onChange={(e) => setNewEnumValue(e.target.value)}
                    style={{ flex: 1, minWidth: "150px" }}
                    onKeyDown={(e) => { if (e.key === "Enter") addEnumOption(); }}
                  />
                  <TextField
                    label={t('modifyExternalApi.descriptionOptional')}
                    variant="outlined"
                    value={newEnumDescription}
                    onChange={(e) => setNewEnumDescription(e.target.value)}
                    style={{ flex: 2, minWidth: "200px" }}
                    onKeyDown={(e) => { if (e.key === "Enter") addEnumOption(); }}
                  />
                  <Button startIcon={<Plus absoluteStrokeWidth />} onClick={addEnumOption} disabled={!newEnumValue.trim()}>
                    {t('common.add')}
                  </Button>
                </div>
                {enumOptions.length > 0 && (
                  <div className={classes.enumList}>
                    {enumOptions.map((option) => (
                      <div key={option.id} className={classes.enumItem}>
                        {editingEnumId === option.id ? (
                          <>
                            <TextField
                              variant="outlined"
                              size="small"
                              value={editEnumValue}
                              onChange={(e) => setEditEnumValue(e.target.value)}
                              style={{ flex: 1, minWidth: "120px" }}
                              onKeyDown={(e) => { if (e.key === "Enter") saveEditEnumOption(); }}
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              value={editEnumDescription}
                              onChange={(e) => setEditEnumDescription(e.target.value)}
                              style={{ flex: 2, minWidth: "180px" }}
                              onKeyDown={(e) => { if (e.key === "Enter") saveEditEnumOption(); }}
                            />
                            <button className={classes.enumActionButton} onClick={saveEditEnumOption}>
                              <Save size={16} />
                            </button>
                          </>
                        ) : (
                          <>
                            <span className={classes.enumValue}>{option.value}</span>
                            <span className={classes.enumDescription}>{option.description}</span>
                            <button className={classes.enumActionButton} onClick={() => startEditEnumOption(option)}>
                              <Pencil size={16} />
                            </button>
                            <button className={classes.enumActionButtonDelete} onClick={() => removeEnumOption(option.id)}>
                              <Trash2 size={16} />
                            </button>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {enumError && (
                  <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em", marginTop: "4px" }}>
                    {t('modifyExternalApi.atLeastOneEnumOption')}
                  </p>
                )}
              </div>
            </div>
          )}
          <div className={classes.buttonContainer}>
            <Button variant="destructive" startIcon={<Trash2 absoluteStrokeWidth />} onClick={handleDialogOpenDel}>
              {t('common.delete')}
            </Button>
            <Button startIcon={<Save absoluteStrokeWidth />} onClick={sendToApi}>
              {t('common.save')}
            </Button>
          </div>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginTop: "16px" }}>
            {apiTypeId === externalApiTypes.STOPWATCH && (
              <>
                <Tooltip content={getQrButtonTooltipContent("Start")}>
                  <div className={classes.qrButtonContainer}>
                    <label className={classes.qrButtonLabel}>{t('modifyExternalApi.qrStartStopwatch')}</label>
                    <ApiMeasurementQrButton apiAction={t('modifyExternalApi.actionStartStopwatch')} apiName={connectionName} qrUrl={generateQRCodeUrl("", "Start")} />
                  </div>
                </Tooltip>
                <Tooltip content={getQrButtonTooltipContent("Stop")}>
                  <div className={classes.qrButtonContainer}>
                    <label className={classes.qrButtonLabel}>{t('modifyExternalApi.qrStopStopwatch')}</label>
                    <ApiMeasurementQrButton apiAction={t('modifyExternalApi.actionStopStopwatch')} apiName={connectionName} qrUrl={generateQRCodeUrl("", "Stop")} />
                  </div>
                </Tooltip>
                <Tooltip content={getQrButtonTooltipContent("LinearStopwatch")}>
                  <div className={classes.qrButtonContainer}>
                    <label className={classes.qrButtonLabel}>{t('modifyExternalApi.qrStartStopToggle')}</label>
                    <ApiMeasurementQrButton apiAction={t('modifyExternalApi.actionStartStopToggle')} apiName={connectionName} qrUrl={generateQRCodeUrl("", "LinearStopwatch")} />
                  </div>
                </Tooltip>
              </>
            )}
            {apiTypeId === externalApiTypes.NUMERIC && (
              <>
                <Tooltip content={getQrButtonTooltipContent("Count")}>
                  <div className={classes.qrButtonContainer}>
                    <label className={classes.qrButtonLabel}>{t('modifyExternalApi.qrCountPlus1')}</label>
                    <ApiMeasurementQrButton apiAction={t('modifyExternalApi.actionCountPlus1')} apiName={connectionName} qrUrl={generateQRCodeUrl("", "Count")} />
                  </div>
                </Tooltip>
              </>
            )}
            {apiTypeId === externalApiTypes.ENUM && enumBehaviorTypeId === externalApiEnumBehaviorTypes.STICKY && enumOptions.length > 0 && (
              <>
                {enumOptions.filter(o => o.isActive).sort((a, b) => a.value.localeCompare(b.value)).map((option) => (
                  <Tooltip key={option.id} content={t('modifyExternalApi.qrEnumTooltip', { behaviorType: enumBehaviorTypeId === externalApiEnumBehaviorTypes.ANCHOR ? t('modifyExternalApi.enumAnchor') : t('modifyExternalApi.enumSticky'), value: option.value })}>
                    <div className={classes.qrButtonContainer}>
                      <label className={classes.qrButtonLabel}>
                        {t('modifyExternalApi.qrEnumLabel', { behaviorType: enumBehaviorTypeId === externalApiEnumBehaviorTypes.ANCHOR ? t('modifyExternalApi.enumAnchor') : t('modifyExternalApi.enumSticky'), value: option.value })}
                      </label>
                      <ApiMeasurementQrButton
                        apiAction={`${enumBehaviorTypeId === externalApiEnumBehaviorTypes.ANCHOR ? t('modifyExternalApi.enumAnchor') : t('modifyExternalApi.enumSticky')}: ${option.value}`}
                        apiName={connectionName}
                        qrUrl={`${appSettings.TAPLR_API_BASE_URL}/ExternalApiMeasurementLogic/NewExternalApiEnumBehaviorMeasurementQuery?apiKey=${apiKey}&enumOptionId=${option.id}`}
                      />
                    </div>
                  </Tooltip>
                ))}
              </>
            )}
          </div>
          {!(apiTypeId === externalApiTypes.ENUM && enumBehaviorTypeId) && (
          <div style={{ marginTop: "20px" }}>
            <label className={classes.label}>{t('modifyExternalApi.uniqueApiLink')}</label>
            <div className={classes.ApiContainer} style={{ marginBottom: "15px" }}>
              {/* <TextField fullWidth disabled multiline value={apiExampleLink} label={apiExampleLink ? " " : "Connection Link"} InputLabelProps={{ shrink: false }} style={{ marginRight: "5px" }} /> */}
              <input className={classes.apiTextField} disabled value={apiExampleLink} label={apiExampleLink ? " " : "API Link"} />
              {
                apiExampleLink === "" ? (
                  // <Button size='large' variant="contained" onClick={handleCopyLink} style={{ background: "var(--color-primary)", color: 'white', marginBottom: "8px" }} startIcon={<ClipboardCopy />} content="Copy">Copy</Button>
                  <button className={classes.disabledIconButton}>
                    <ClipboardCopy className={classes.iconButton__icon} absoluteStrokeWidth />
                    {t('common.copy')}
                  </button>
                ) : (
                  <button className={classes.primaryIconButton} onClick={handleCopyLink}>
                    <ClipboardCopy className={classes.iconButton__icon} absoluteStrokeWidth />
                    {t('common.copy')}
                  </button>
                )
                // <Button disabled size='large' variant="contained" onClick={handleCopyLink} style={{ color: 'white', marginBottom: "8px" }} startIcon={<ClipboardCopy />} content="Copy">Copy</Button>
              }
            </div>
            <label className={classes.label}>{t('modifyExternalApi.apiFormatExample')}</label>
            <div className={classes.ApiFormatContainer}>
              {externalApiType?.id === externalApiTypes.STOPWATCH && <BoolToggle label={t('modifyExternalApi.useCustomReference')} size="small" boolValue={usingCustomReference} onChange={handleStopwatchExampleBody} />}
              <div style={{ width: "100%", display: "flex", alignItems: "end", gap: "8px" }}>
                <TextField
                  fullWidth
                  disabled
                  multiline
                  value={exampleBody}
                  label={exampleBody ? " " : t('modifyExternalApi.connectionExamplePlaceholder')}
                  InputLabelProps={{ shrink: false }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                    },
                  }}
                />
                <div className={classes.ApiFormatContainer__buttonContainer}>
                  <Button variant="ghost" onClick={() => handleTutorialDialog()}>
                    {t('modifyExternalApi.howDoIUseThis')}
                  </Button>
                  {
                    exampleBody === "" ? (
                      // <Button size='large' variant="contained" onClick={handleCopyFormat} style={{ background: "var(--color-primary)", color: 'white', marginBottom: "8px" }} startIcon={<ClipboardCopy />} content="Copy">Copy</Button>
                      <button className={classes.disabledIconButton}>
                        <ClipboardCopy className={classes.iconButton__icon} absoluteStrokeWidth />
                        {t('common.copy')}
                      </button>
                    ) : (
                      <button className={classes.primaryIconButton} onClick={handleCopyFormat}>
                        <ClipboardCopy className={classes.iconButton__icon} absoluteStrokeWidth />
                        {t('common.copy')}
                      </button>
                    )
                    // <Button disabled size='large' variant="contained" onClick={handleCopyFormat} style={{ color: 'white', marginBottom: "8px" }} startIcon={<ClipboardCopy />} content="Copy">Copy</Button>
                  }
                </div>
              </div>
            </div>
          </div>
          )}
        </div>
      </Box>
      <Snackbar open={openToast} autoHideDuration={3000} onClose={handleCloseToast} message={t('modifyExternalApi.copiedToClipboard')} />

      <HowToUseAPIDialog dialogOpen={howToOpen} closeDialog={() => setHowToOpen(false)} apiTypeId={externalApiType && externalApiType.id} apiUrl={apiExampleLink} apiBodyItems={apiBodyItems} />

      <Dialog open={delopen} onClose={handleDialogCloseDel} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{t('modifyExternalApi.deleteApiTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{t('modifyExternalApi.deleteApiConfirm', { name: htConnectionName })}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonNormalText content={t('common.close')} onClick={handleDialogCloseDel}>
            {t('common.close')}
          </ButtonNormalText>
          <ButtonNormalDelete startIcon={<Trash2 />} content={t('common.delete')} onClick={handleDeleteExternalApi}>
            {t('common.delete')}
          </ButtonNormalDelete>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModifyExternalApiPage;
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "1.5rem",
    width: "100%",
    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: "48px",
  },
  qrButton: {
    backgroundColor: "var(--color-primary)",
  },
  buttonContainer: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: "8px",
  },

  formContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: "16px",

    marginBottom: "16px",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "8px",
    },
  },

  formColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  projectOption: {
    minWidth: "240px",
    maxWidth: "100%",

    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },

  labelContainer__label: {
    fontSize: "16px",
    color: "rgb(105, 105, 105)",
    margin: "0",
  },

  label: {
    display: "inline-block",
    fontSize: "16px",
    color: "rgb(105, 105, 105)",
    margin: "0",
    marginBottom: "4px",
  },

  labelContainer__helperText: {
    fontSize: "16px",
    color: "#D84949",
    margin: "0",
  },

  listDescriptionStyle: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    position: "relative",
  },

  description__textarea: {
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    padding: "8px",
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    backgroundColor: "transparent",
    border: "1px solid #BDBDBD",
    borderRadius: "4px",
    resize: "none",

    [theme.breakpoints.down("sm")]: {
      height: "120px",
    },
  },

  generateApiKeyContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  ApiContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    border: "1px solid #989898",
    borderRadius: "4px",

    padding: "8px",
  },

  ApiFormatContainer: {
    height: "fit-content",

    display: "flex",
    flexDirection: "column",

    border: "1px solid #989898",
    borderRadius: "4px",

    padding: "8px",
  },

  apiTextField: {
    height: "40px",
    width: "100%",

    fontSize: "16px",

    backgroundColor: "transparent",
    border: "none",
  },

  generateApiKeyButton: {
    backgroundColor: "var(--color-primary)",
    color: "white",
    width: "220px",
    borderRadius: "4px",
    border: "none",
    outline: "none",
    cursor: "pointer",
    marginRight: "5px",
    height: "55px",
    fontSize: "15px",
  },

  primaryButton: {
    height: "40px",
    padding: "0 16px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "var(--color-primary)",

    transition: "all 0.2s ease-in-out",
    whiteSpace: "nowrap",

    userSelect: "none",

    "&:hover": {
      backgroundColor: "#a77d4f",
      cursor: "pointer",
    },
  },

  primaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "var(--color-primary)",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  disabledIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#DCDCDC",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    "&:hover": {
      cursor: "not-allowed",
    },
  },

  secondaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "1px solid #a77d4f",
    borderRadius: "4px",

    fontSize: "16px",
    color: "#a77d4f",
    backgroundColor: "transparent",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      border: "1px solid #a77d4f",
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  deleteButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",
    border: "1px solid #D84949",
    borderRadius: "4px",
    fontSize: "16px",
    color: "#D84949",
    backgroundColor: "transparent",
    display: "flex",
    gap: "8px",
    alignItems: "center",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      border: "1px solid #D84949",
      backgroundColor: "#D84949",
      color: "white",
      cursor: "pointer",
    },
  },

  iconButton__icon: {
    height: "20px",
    width: "20px",
    strokeWidth: "2px",

    display: "block",
  },

  ApiFormatContainer__buttonContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  qrButtonContainer: {
    display: "flex",
    borderRadius: "8px",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    padding: "0.5rem",
    paddingLeft: "1rem",
    backgroundColor: "#F8F8F8",
    border: "1px solid #EDEDED",
    cursor: "default",
  },

  qrButtonLabel: {
    fontSize: "16px",
    color: "#0C0E29",
    margin: "0",
  },

  enumContainer: {
    border: "1px solid #989898",
    borderRadius: "4px",
    padding: "16px",
    marginTop: "4px",
  },

  enumInputRow: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    flexWrap: "wrap",
  },

  enumList: {
    marginTop: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  enumItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    border: "1px solid #e0e0e0",
  },

  enumValue: {
    flex: 1,
    fontWeight: "600",
    fontSize: "14px",
    color: "#0C0E29",
    minWidth: "120px",
  },

  enumDescription: {
    flex: 2,
    fontSize: "14px",
    color: "#696969",
    minWidth: "180px",
  },

  enumActionButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "transparent",
    color: "#0B4097",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },

  enumActionButtonDelete: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "transparent",
    color: "#d32f2f",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: "#fce4e4",
    },
  },
}));